var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.jjfaVisible),
      expression: "!jjfaVisible"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n        签约项目管理-详情\n    ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "820px",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "350px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "margin-top": "9px",
      "padding-top": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px",
      "margin-top": "20px",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "94%",
      "margin": "0 3%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "right",
      "width": "16%",
      "color": "#b6b6b6"
    }
  }, [_vm._v("组织架构：")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$globals.group_name + '/' + _vm.form.organize_name))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "width": "16%",
      "color": "#b6b6b6"
    }
  }, [_vm._v("城市：")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.form.city))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "width": "16%",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同编码：")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.form.contract_code))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("甲方名头：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.party_title))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同名称：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_name))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同开始时间：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_start_date))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同终止时间：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_end_date))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同核算单位：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_unit_title))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("服务费核算标准：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.service_charge_standard_title))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("项目名称：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.project_name))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("乙方名头：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.partner_name))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("项目地址：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.project_site))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v(_vm._s(_vm.contract_headcount_label) + "：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_headcount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v(_vm._s(_vm.contract_min_count_label) + "：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_min_count))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("是否使用客户要求：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.is_client_require_title))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同要求每日每人最多工时：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_max_labor_hour))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同要求每日最少工时：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_min_day_labor_hour))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right",
      "color": "#b6b6b6"
    }
  }, [_vm._v("合同要求每月最少工时：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.contract_min_month_labor_hour))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "margin-top": "20px",
      "padding-top": "20px",
      "margin-bottom": "40px",
      "padding-bottom": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B",
      "padding-top": "8px",
      "padding-bottom": "8px"
    },
    on: {
      "click": _vm.PostFind
    }
  }, [_vm._v("选择岗位")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px",
      "margin-top": "20px",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-left": "30px",
      "padding-right": "30px"
    }
  }, _vm._l((_vm.checkProjectPostList), function(item, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('shift', {
      ref: "shift",
      refInFor: true,
      attrs: {
        "projectPost": _vm.projectPostList[index]
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.baici
    }
  }, [_vm._v("保存\n                ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("生成解决方案\n                ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("历史解决方案\n                ")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择岗位",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.PostChange
    },
    model: {
      value: (_vm.checkProjectPostList),
      callback: function($$v) {
        _vm.checkProjectPostList = $$v
      },
      expression: "checkProjectPostList"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.post_name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('jjfa', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jjfaVisible),
      expression: "jjfaVisible"
    }],
    ref: "jjfa",
    attrs: {
      "ruleForm": _vm.ruleForm
    },
    on: {
      "return": _vm.Return
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设置班次",
      "visible": _vm.dialogVisibles,
      "width": "50%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('div', [_c('el-row', {
    staticStyle: {
      "height": "506px",
      "overflow-y": "scroll"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "model": _vm.projectPost,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班次:"
    }
  }, _vm._l((_vm.form.shiftCount), function(item, index) {
    return _c('el-row', {
      key: index,
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('el-form', {
      ref: "shiftForm",
      refInFor: true,
      attrs: {
        "model": _vm.form.shiftList[index],
        "rules": _vm.shiftRules
      }
    }, [_c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("班次" + _vm._s(index + 1))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]), _vm._v("工作时间")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "start_time"
      }
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "85%"
      },
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        }
      },
      model: {
        value: (_vm.form.shiftList[index].start_time),
        callback: function($$v) {
          _vm.$set(_vm.form.shiftList[index], "start_time", $$v)
        },
        expression: "form.shiftList[index].start_time"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "-10px"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v("—")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "end_time"
      }
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "85%"
      },
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        }
      },
      model: {
        value: (_vm.form.shiftList[index].end_time),
        callback: function($$v) {
          _vm.$set(_vm.form.shiftList[index], "end_time", $$v)
        },
        expression: "form.shiftList[index].end_time"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]), _vm._v("人数")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "person_count"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (_vm.form.shiftList[index].person_count),
        callback: function($$v) {
          _vm.$set(_vm.form.shiftList[index], "person_count", $$v)
        },
        expression: "form.shiftList[index].person_count"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index + 1) == _vm.form.shiftCount.length),
        expression: "(index + 1) == form.shiftCount.length"
      }],
      attrs: {
        "src": require("../../../assets/icon/添加.png"),
        "width": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.shiftAdd(index)
        }
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      attrs: {
        "src": require("../../../assets/icon/减少.png"),
        "width": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.shiftRemove(index)
        }
      }
    })])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibles = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "120px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存\n        ")])], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E4B solid",
      "height": "20px",
      "width": "100%",
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px",
      "font-size": "20px",
      "line-height": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("基础信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E4B solid",
      "height": "20px",
      "width": "100px",
      "margin-left": "30px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px",
      "font-size": "20px",
      "line-height": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("岗位设置")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ae0f34","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/znpb/QyxmGl/QyxmGl_edit.vue
// module id = null
// module chunks = 